import {
    Component,
    model,
    OnDestroy,
    OnInit,
    inject,
    Signal,
    computed,
    signal,
    DestroyRef,
    effect,
    untracked,
} from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AssetPageService } from './asset-page.service';
import {
    ViewportScroller,
    NgClass,
    AsyncPipe,
    KeyValuePipe,
    DOCUMENT,
} from '@angular/common';
import { AssetForPortalFullAssetPage } from '../shared/interfaces/research-portal/full-asset-page/asset-for-portal-full-asset-page.interface';
import { EsploroAssetForPortalFullAssetPage } from '../shared/interfaces/research-portal/full-asset-page/esploro-asset-for-portal-full-asset-page.interface';
import { Author } from '../shared/interfaces/research-portal/full-asset-page/asset-model/asset-model-relations/author.interface';
import {
    MatDialog,
    MatDialogTitle,
    MatDialogClose,
    MatDialogContent,
    MatDialogActions,
} from '@angular/material/dialog';
import { UrlUtils } from '../shared/utils/url.utils';
import { LinkMetadataForFullAssetPage } from '../shared/interfaces/research-portal/full-asset-page/asset-model/general-helpers-model/link-metadata-for-full-asset-page.interface';
import { FileMetadataForFullAssetPage } from '../shared/interfaces/research-portal/full-asset-page/asset-model/general-helpers-model/file-metadata-for-full-asset-page.interface';
import { RelatedContentForFullAssetPage } from '../shared/interfaces/research-portal/full-asset-page/related-content-for-full-asset-page.interface';
import { ConfigurationHandlerService } from '../core/configuration-handler.service';
import { FullAssetPage } from '../shared/configurations/full-asset-page.constant';
import {
    LangChangeEvent,
    TranslateService,
    TranslateModule,
} from '@ngx-translate/core';
import {
    ExportersService,
    ShareService,
    ShareTarget,
    InfobarComponent,
    MultipleEventsDirective,
    InputExpanderDirective,
    ContextFrameComponent,
    SeparatorComponent,
    StatusTagComponent,
    DictionaryComponent,
    DictionaryItemComponent,
    DictionaryItemContentDirective,
    SdgIconListComponent,
    ActionListItemComponent,
} from '@exl-ng/mulo-common';
import {
    DisplayMode,
    MediaService,
    HideOnPrintDirective,
} from '@exl-ng/mulo-core';

import {
    asyncScheduler,
    catchError,
    filter,
    iif,
    map,
    Observable,
    Subject,
    switchMap,
    takeUntil,
    tap,
    throwError,
} from 'rxjs';
import { I18nService } from '../core/i18n.service';
import { AssetExportService } from './asset-page-export/asset-export.service';
import { AssetSeoService } from './asset-seo.service';
import { HttpErrorResponse } from '@angular/common/http';
import { PortalConfiguration } from '../shared/interfaces/research-portal/portal-configuration/portal-configuration.interface';
import { FullAssetPageShareActionsConfiguration } from '../shared/interfaces/research-portal/portal-configuration/full-asset-page-share-actions-configuration.interface';
import { PortalEsploroSectionsConfiguration } from '../shared/interfaces/research-portal/portal-configuration/portal-esploro-sections-configuration';
import { FullAssetPageEssentialsConfiguration } from '../shared/interfaces/research-portal/portal-configuration/full-asset-page-essentials-configuration.interface';
import { FullAssetPageCreatorsConfiguration } from '../shared/interfaces/research-portal/portal-configuration/full-asset-page-creators-configuration.interface';
import { FullAssetPageIdentifiersConfiguration } from '../shared/interfaces/research-portal/portal-configuration/full-asset-page-identifiers-configuration.interface';
import { StorageUtilService } from '../core/storage-util.service';
import { CookiesSnackbarComponent } from '../parts/snackbars/cookies-snackbar/cookies-snackbar.component';
import { SnackbarService } from '../core/snackbar.service';
import { CollectionsService } from '../collections/collections.service';
import { Collection } from '../shared/interfaces/collection.interface';
import { InciteMetricsDTO } from '../shared/external-model/incitemetrics/incite-metrics-dto';
import {
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators,
    FormsModule,
    ReactiveFormsModule,
} from '@angular/forms';
import { getTranslatableValue } from '../shared/interfaces/translatable';
import { validateDoiFormat } from '../shared/validators/doi.validator';
import { CodeTableService } from '../core/code-table.service';
import { CodeLabelEntry } from '../shared/interfaces/code-label-entry.interface';
import {
    AssetFieldType,
    AssetFieldTypeEnum,
    getAssetFieldTypeKey,
    isLocalField,
} from '../shared/interfaces/asset/revision/asset-field-type';
import { JwtUtilService } from '../core/jwt-util.service';
import { WidthInAnimation, WidthOutAnimation } from '@exl-ng/mulo-common';
import { AssetRevisionChangesDTO } from '../shared/interfaces/asset/revision/asset-revision-changes-dto';
import { EntityService } from '../core/entity.service';
import { EntityLocalFields } from '../shared/interfaces/entitiy-local-fields.interface';
import { ResourceTypeUtils } from '../shared/utils/resource-type.utils';
import { DefaultTranslatePipe } from '../shared/pipes/default-translate.pipe';
import { ListitemDescriptionA11yDirective } from '../shared/directives/a11y/description/listitem-description-a11y.directive';
import {
    MatSelectionList,
    MatListOption,
    MatList,
    MatListItemIcon,
} from '@angular/material/list';
import { IncitesHighlightsComponent } from './asset-page-sections/incites-highlights/incites-highlights.component';
import { DetailsComponent } from './asset-page-sections/details/details.component';
import { EntityLocalFieldsComponent } from '../parts/entities/entity-local-fields/entity-local-fields.component';
import { RelatedContentComponent } from './asset-page-sections/related-content/related-content.component';
import { UsageMetricsComponent } from './asset-page-sections/usage-metrics/usage-metrics.component';
import { AssetFilesAndLinksComponent } from './asset-page-sections/files-and-links/asset-files-and-links.component';
import { DescriptionAndKeywordsComponent } from './asset-page-sections/description-and-keywords/description-and-keywords.component';
import { CollectionsEssentialsComponent } from './asset-page-essentials/collections-essentials/collections-essentials.component';
import { AssetPageMetadataEssentialsComponent } from './asset-page-essentials/asset-page-metadata-essentials/asset-page-metadata-essentials.component';
import { AuthorsEssentialsComponent } from './asset-page-essentials/authors-essentials/authors-essentials.component';
import { DepositDoiComponent } from '../deposit/deposit-sections/deposit-doi/deposit-doi.component';
import { DepositTypeComponent } from '../deposit/deposit-sections/deposit-type/deposit-type.component';
import { MatInput } from '@angular/material/input';
import {
    MatFormField,
    MatLabel,
    MatError,
    MatHint,
} from '@angular/material/form-field';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIcon } from '@angular/material/icon';
import { MatAnchor, MatIconButton, MatButton } from '@angular/material/button';
import {
    PageBaseComponent,
    PageMastComponent,
    NavMainLayoutComponent,
    PageSectionComponent,
    BriefComponent,
} from '@exl-ng/mulo-views';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { DepositFormService } from '../deposit/deposit-form.service';

type AssetDisplayMode = DisplayMode | 'viewchanges';

@Component({
    selector: 'esp-asset-page',
    templateUrl: './asset-page.component.html',
    styleUrls: ['./asset-page.component.scss'],
    animations: [WidthInAnimation, WidthOutAnimation],
    providers: [{ provide: EntityService, useExisting: AssetPageService }],
    imports: [
        PageBaseComponent,
        PageMastComponent,
        InfobarComponent,
        NavMainLayoutComponent,
        MatAnchor,
        MultipleEventsDirective,
        MatIcon,
        MatProgressSpinner,
        MatDialogTitle,
        MatIconButton,
        MatDialogClose,
        CdkScrollable,
        MatDialogContent,
        MatFormField,
        InputExpanderDirective,
        MatLabel,
        MatInput,
        FormsModule,
        MatDialogActions,
        MatButton,
        ContextFrameComponent,
        ReactiveFormsModule,
        DepositTypeComponent,
        MatError,
        DepositDoiComponent,
        NgClass,
        SeparatorComponent,
        StatusTagComponent,
        AuthorsEssentialsComponent,
        AssetPageMetadataEssentialsComponent,
        HideOnPrintDirective,
        RouterLink,
        CollectionsEssentialsComponent,
        PageSectionComponent,
        DescriptionAndKeywordsComponent,
        AssetFilesAndLinksComponent,
        UsageMetricsComponent,
        RelatedContentComponent,
        MatHint,
        DictionaryComponent,
        DictionaryItemComponent,
        DictionaryItemContentDirective,
        EntityLocalFieldsComponent,
        DetailsComponent,
        TranslateModule,
        IncitesHighlightsComponent,
        MatSelectionList,
        MatListOption,
        SdgIconListComponent,
        MatList,
        ActionListItemComponent,
        ListitemDescriptionA11yDirective,
        MatListItemIcon,
        BriefComponent,
        AsyncPipe,
        KeyValuePipe,
        DefaultTranslatePipe,
    ],
})
export class AssetPageComponent implements OnInit, OnDestroy {
    private route = inject(ActivatedRoute);
    private router = inject(Router);
    private assetPageService = inject(AssetPageService);
    private viewportScroller = inject(ViewportScroller);
    private dialog = inject(MatDialog);
    private cfgSvc = inject(ConfigurationHandlerService);
    private translate = inject(TranslateService);
    private exportersService = inject(ExportersService);
    media = inject(MediaService);
    i18nService = inject(I18nService);
    private assetSeoService = inject(AssetSeoService);
    private assetExportSvc = inject(AssetExportService);
    private shareService = inject(ShareService);
    private storageService = inject(StorageUtilService);
    private snackbarService = inject(SnackbarService);
    private collectionsService = inject(CollectionsService);
    private document = inject<Document>(DOCUMENT);
    _window = this.document.defaultView;
    private fb = inject(UntypedFormBuilder);
    private ctSvc = inject(CodeTableService);
    private jwtSvc = inject(JwtUtilService);
    private depositFormSvc = inject(DepositFormService);

    readonly loading = signal(false);
    mmsID;
    doi;
    wosIdentifier;

    readonly sections = computed(() => {
        const cfg = this.cfgSvc.portalConfigurationByDefaultAssetType();
        return (cfg.sections || []).filter((section) => section.active);
    });
    essentials: FullAssetPageEssentialsConfiguration[] = [];

    isDOILinkableByConfiguration: boolean;
    isHandleLinkableByConfiguration: boolean;
    identifiersCodesToDisplay = [];
    readonly creatorsConfig: Signal<FullAssetPageCreatorsConfiguration> =
        computed(() => {
            const config = this.cfgSvc.portalConfigurationByDefaultAssetType();
            return config.essentialsFix?.find(
                (item) => item.code === 'esploroCreators',
            )?.esploroCreators;
        });

    readonly record = signal<AssetForPortalFullAssetPage>(undefined);
    readonly creators = computed(() => {
        let creators = this.fullAssetPageRep()?.creators;

        if (!this.creatorsConfig()?.incdludeGroupAuthors) {
            creators = creators.filter(
                (creator) => creator.source !== 'groupAuthor',
            );
        }
        return creators.filter(
            (creator) =>
                this.creatorsConfig()?.filterOutRoles.indexOf(creator.role) ===
                -1,
        );
    });
    collections: Collection[] = [];

    assetsIdentifiersToDisplay = {};

    readonly fullAssetPageRep = computed(
        () => this.record()?.esploroAssetForPortalFullAssetPage,
    );

    readonly accessStatus = computed(() =>
        this.isOpenAccess()
            ? 'research.portal.fulldisplay.access.open'
            : 'research.portal.fulldisplay.access.closed',
    );
    readonly accessIcon = computed(() =>
        this.isOpenAccess() ? 'open-access' : 'lock',
    );
    readonly showUserDetails = computed(() => {
        const creators = this.creators();
        const creatorCfg = this.creatorsConfig();

        const hasAffiliation = creators?.filter(
            (creator) => creator.affiliationName,
        );
        const hasRole = creators?.filter((creator) => creator.role);

        return (
            (creatorCfg?.displayAutorAffilations &&
                hasAffiliation?.length > 0) ||
            (creatorCfg?.displayRoles && hasRole?.length > 0)
        );
    });
    readonly displayDownloadButton = computed(
        () =>
            this.sections()?.filter((section) => section.code === 'filesLinks')
                .length > 0 &&
            this.files()?.filter(this.accessibleFiles).length > 0,
    );
    readonly displayExportButton = computed(
        () =>
            this.cfgSvc
                .portalConfigurationByDefaultAssetType()
                ?.sendToActions?.filter(
                    (action) => action.active && action.code !== 'PermaLink',
                )?.length > 0,
    );
    readonly displayShareButton = computed(
        () =>
            this.cfgSvc
                .portalConfigurationByDefaultAssetType()
                ?.sendToActions?.find((action) => action.code === 'PermaLink')
                ?.active,
    );

    readonly licenseMessage = computed(() => {
        const license = this.fullAssetPageRep()?.licenseDetails;
        if (license && license.isMultiple) {
            return 'research.portal.fulldisplay.multiple.licenses';
        } else if (license && license.licenseCode) {
            return license.licenseCode + '.name';
        }
        return '';
    });
    readonly licenseURL = computed(() => {
        const license = this.fullAssetPageRep()?.licenseDetails;
        if (
            license &&
            !license.isMultiple &&
            license.licenseCode &&
            license.licenseURL
        ) {
            return license.licenseURL;
        }
        return '';
    });

    readonly files = computed(() => this.fullAssetPageRep()?.filesMetadata);
    readonly fileViewBtnIdx = computed(() =>
        this.files()?.findIndex(this.accessibleFiles),
    );
    readonly links = computed(() => this.fullAssetPageRep()?.linksMetadata);
    relations: RelatedContentForFullAssetPage[] = [];

    shareTargets: ShareTarget[] = [];

    institutionCode = UrlUtils.getParam('institution');

    destroyRef = inject(DestroyRef);

    emptyRecordTitle: string;
    errorStatus: string;

    readonly isQuickAccess = signal(false);

    readonly incitesHighlights = signal<InciteMetricsDTO>(undefined);
    readonly sdgs = signal<number[]>([]);
    readonly isSdgsFromIncites = signal(false);

    readonly displayMode = signal<AssetDisplayMode>('view');
    readonly isMastFormOpen = signal(false);
    readonly isSdgFormOpen = signal(false);
    mastForm = this.fb.group({
        [AssetFieldTypeEnum.AssetType]: ['', Validators.required],
        [AssetFieldTypeEnum.Title]: ['', Validators.required],
        [AssetFieldTypeEnum.Subtitle]: [''],
        [AssetFieldTypeEnum.Doi]: ['', validateDoiFormat],
    });
    readonly sdgRevisions = signal([]);
    readonly sectionSubmitInProgress = signal(false);
    allSdgs: CodeLabelEntry[] = [];
    assetRevision: { [k in AssetFieldType]?: any } = {};
    readonly isEditable = computed(() => this.fullAssetPageRep()?.userCanEdit);
    readonly showEditBtn = computed(
        () => this.jwtSvc.isLoggedIn() && this.isEditable() != null,
    );
    submitNote = model('');
    submitLoading = signal(false);
    protected readonly AssetFieldTypeEnum = AssetFieldTypeEnum;

    pageData$: Observable<AssetForPortalFullAssetPage>;
    getRevisionChanges$: Observable<any>;
    getPendingChanges$: Observable<any>;
    submitRevision$: Observable<any>;
    revisionConfig$: Observable<Map<AssetFieldType, boolean>>;

    mediaMentions$: Observable<any>;

    readonly localFields = signal<EntityLocalFields[]>([]);
    readonly localFieldNames = signal<string[]>([]);

    useAltOAIcon = computed(
        () =>
            this.cfgSvc.config()?.customerParameters?.[
                'esploro_alt_open_access_icon'
            ] === 'true',
    );
    hasPubDetails$: Observable<boolean>;
    pubDetailsForm = this.fb.group({
        [AssetFieldTypeEnum.Volume]: [''],
        [AssetFieldTypeEnum.Issue]: [''],
        [AssetFieldTypeEnum.Pages]: [''],
    });
    isPubDetailsFormOpen = signal(false);
    readonly filteredLocalFields = computed(() =>
        this.localFields()
            .filter((field) => this.localFieldNames().includes(field.code))
            .sort(
                (a, b) =>
                    parseInt(a.code.replace('LocalField', '')) -
                    parseInt(b.code.replace('LocalField', '')),
            ),
    );
    readonly requiredLocalFields = computed(() => {
        const requiredFields = this.fieldRequiredMap();
        const filtered = [];
        requiredFields?.forEach((isRequired, key) => {
            if (isLocalField(key) && isRequired) {
                filtered.push(getAssetFieldTypeKey(key));
            }
        });
        return filtered;
    });

    mastFormValue = toSignal(this.mastForm.valueChanges);
    pubDetailsFormValue = toSignal(this.pubDetailsForm.valueChanges);
    fieldRequiredMap = signal(new Map<AssetFieldType, boolean>());
    requiredFieldsMissing = computed(() => {
        const missingFields: AssetFieldType[] = [];
        const localFields = this.localFields();
        const sdgCount = this.sdgs().length;
        const mastFormValue = this.mastFormValue();
        const pubDetailsFormValue = this.pubDetailsFormValue();
        this.fieldRequiredMap()?.forEach((isRequired, key) => {
            if (isRequired) {
                const mastFormCheck =
                    !this.mastForm.get(key) || !!mastFormValue[key];
                const pubDetailsFormCheck =
                    !this.pubDetailsForm.get(key) || !!pubDetailsFormValue[key];
                const lfKey = getAssetFieldTypeKey(key);
                const lfCheck =
                    !isLocalField(key) ||
                    localFields.some(
                        (lf) => lf.code === lfKey && !!lf.localFieldValue,
                    );
                const sdgCheck = key !== AssetFieldTypeEnum.Sdg || sdgCount > 0;

                if (
                    !mastFormCheck ||
                    !pubDetailsFormCheck ||
                    !lfCheck ||
                    !sdgCheck
                ) {
                    missingFields.push(key);
                }
            }
        });
        return missingFields;
    });
    requiredFieldLabels = signal(new Map<string, string>());

    constructor() {
        effect(() => {
            if (this.displayMode() === 'edit') {
                const isRequiredMap = this.fieldRequiredMap();
                for (const key in this.mastForm.controls) {
                    const isRequired = isRequiredMap?.get(
                        key as AssetFieldType,
                    );
                    if (isRequired) {
                        this.mastForm
                            .get(key)
                            ?.setValidators(Validators.required);
                    } else {
                        this.mastForm
                            .get(key)
                            ?.removeValidators(Validators.required);
                    }
                }
                for (const key in this.pubDetailsForm.controls) {
                    const isRequired = isRequiredMap?.get(
                        key as AssetFieldType,
                    );
                    if (isRequired) {
                        this.pubDetailsForm
                            .get(key)
                            ?.setValidators(Validators.required);
                    } else {
                        this.pubDetailsForm
                            .get(key)
                            ?.removeValidators(Validators.required);
                    }
                }
            }
        });
        effect(() => {
            const localFields = [];
            const requiredLocalFields = this.requiredLocalFields();
            const lfModel =
                this.fullAssetPageRep()?.entityModel?.localFields?.fields;
            for (const key in lfModel) {
                const lfObj = lfModel[key];
                const fieldName = 'LocalField' + lfModel[key].fieldNumber;
                const exists = untracked(this.localFields).some(
                    (_) => _.code === fieldName,
                );

                if (!exists && requiredLocalFields.includes(fieldName)) {
                    localFields.push({
                        parentId: this.mmsID,
                        code: fieldName,
                        localFieldValue: lfObj.fieldValue,
                    });
                }
            }

            this.localFields.update((prev) => [...prev, ...localFields]);
        });
    }
    ngOnInit() {
        this.buildConfigurationForAssetFullPage();
        this.revisionConfig$ = this.cfgSvc
            .getMappingTableEnabledMap$('ResearcherAssetRevisionConfiguration')
            .pipe(
                tap((enabledMap) => {
                    const enabledLocalFields = [];

                    enabledMap.forEach((isEnabled, key) => {
                        const control =
                            this.mastForm.get(key) ||
                            this.pubDetailsForm.get(key);
                        if (control) {
                            if (isEnabled === false) {
                                control?.disable();
                            } else {
                                control?.enable();
                            }
                        }
                        const name = getAssetFieldTypeKey(key);
                        if (isEnabled && name.startsWith('LocalField')) {
                            enabledLocalFields.push(name);
                        }
                    });
                    // sort local fields by number
                    enabledLocalFields.sort(
                        (a, b) =>
                            parseInt(a.replace('LocalField', '')) -
                            parseInt(b.replace('LocalField', '')),
                    );
                    this.localFieldNames.set(enabledLocalFields);
                }),
            );
        this.hasPubDetails$ = this.assetPageService.pageData$.pipe(
            map((data) => {
                const type =
                    data.esploroAssetForPortalFullAssetPage.resourceTypeValue;
                return (
                    ResourceTypeUtils.isPublicationJournalArticle(type) ||
                    ResourceTypeUtils.isPublicationBookReview(type) ||
                    ResourceTypeUtils.isPublicationMoreInformation(type)
                );
            }),
        );

        this.route.url
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                tap((paths) => {
                    const qParams = this.route.snapshot.queryParams;
                    const forceView = qParams?.forceView === 'true';
                    this.displayMode.set(qParams?.mode as AssetDisplayMode);

                    this.mmsID = paths[paths.length - 1].path;
                    this.loading.set(true);
                    this.loadFullAssetPageData(forceView);
                    this.assetPageService.changeEntityId(this.mmsID);
                    this.mediaMentions$ =
                        this.assetPageService.getAssetMediaMentions(this.mmsID);
                }),
                switchMap(() => this.pageData$),
                tap(() => {
                    this.loading.set(false);
                    this.loadAssetCollections();
                    this.setupRevisionObservables();
                }),
                switchMap(() =>
                    iif(
                        () => this.isEditable(),
                        this.getRevisionChanges$,
                        this.getPendingChanges$,
                    ),
                ),
            )
            .subscribe();

        this.reloadAssetAfterLanguageChange();

        this.displayCookeisUsageMessage();
        const queryParams = this.route.snapshot.queryParams;
        if (queryParams?.mode === 'quickaccess') {
            this.isQuickAccess.set(true);
            document.body.classList.add('quick-access');
        }
        this.ctSvc
            .getCodeTable('ResearchSustainabilityGoals')
            .subscribe(
                (codeLabels) =>
                    (this.allSdgs = codeLabels.sort((a, b) =>
                        a.code.localeCompare(b.code),
                    )),
            );
        this.ctSvc
            .getCodeTable('AssetRevisionFields')
            .subscribe((codeLabels) =>
                this.requiredFieldLabels.set(
                    codeLabels.reduce(
                        (returnObj, ctEntry) =>
                            returnObj.set(ctEntry.code, ctEntry.description),
                        new Map<string, string>(),
                    ),
                ),
            );
    }

    assetTitleDisplay = computed(() => {
        const hasRevision =
            ['edit', 'viewchanges'].includes(this.displayMode()) &&
            (this.assetRevision[AssetFieldTypeEnum.Title] !== undefined ||
                this.assetRevision[AssetFieldTypeEnum.Subtitle] !== undefined);
        if (hasRevision) {
            const titles =
                this.fullAssetPageRep()?.entityModel?.titles?.titles?.MAIN;
            const currLang = this.translate.currentLang;

            const title =
                this.assetRevision[AssetFieldTypeEnum.Title] ??
                getTranslatableValue(titles?.titlesList, currLang)[0];
            const subtitle =
                this.assetRevision[AssetFieldTypeEnum.Subtitle] ??
                getTranslatableValue(titles?.subTitlesList, currLang)[0];
            return `${title}${subtitle ? `: ${subtitle}` : ''}`;
        } else {
            return this.fullAssetPageRep()?.title;
        }
    });

    loadAssetCollections() {
        this.collectionsService
            .getCollectionCodesByEntityId(this.mmsID)
            .subscribe((data) => {
                this.collections = data;
            });
    }

    displayCookeisUsageMessage() {
        const cookieName = 'esploro_irus_uk';
        if (this.cfgSvc.config()?.irusConfig?.displayInfoMsgOnPortal) {
            if (!this.storageService.check(cookieName)) {
                const snackBarRef = this.snackbarService.showComponent(
                    CookiesSnackbarComponent,
                    this.cfgSvc.config()?.irusConfig?.infoMsg,
                    0,
                    'bottom',
                    'exl-cookeis-snackbar',
                );
                snackBarRef.onAction()?.subscribe(() => {
                    this.storageService.setItem(cookieName, 'approved');
                });
            }
        }
    }

    reloadAssetAfterLanguageChange() {
        this.translate.onLangChange
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                tap(() => {
                    console.info(
                        'changing language, reload asset in ' +
                            this.i18nService.getLanguage(),
                    );
                }),
                switchMap(() => this.pageData$),
            )
            .subscribe();
    }

    loadFullAssetPageData(forceView = false) {
        this.assetPageService.setForceView(forceView);
        this.pageData$ = this.assetPageService.pageData$.pipe(
            tap((data) => {
                this.onSuccess(data);
                this.addGoogleMetaTags();
            }),
            catchError((error) => {
                this.onError(error);
                return throwError(error);
            }),
        );
    }

    addGoogleMetaTags() {
        asyncScheduler.schedule(
            () => this.assetSeoService.addGoogleMetaTags(this.record()),
            0,
        );
    }

    onSuccess(data: AssetForPortalFullAssetPage) {
        this.loading.set(false);
        this.record.set(data);

        this.fieldRequiredMap.set(null);
        if (data) {
            const fullAssetPageRep = data.esploroAssetForPortalFullAssetPage;
            const titles = fullAssetPageRep?.entityModel?.titles?.titles?.MAIN;
            const currLang = this.translate.currentLang;
            const fieldTypeMap = {
                assetType: AssetFieldTypeEnum.AssetType,
                sdg: AssetFieldTypeEnum.Sdg,
                doi: AssetFieldTypeEnum.Doi,
                title: AssetFieldTypeEnum.Title,
                subtitle: AssetFieldTypeEnum.Subtitle,
                isPartOfVolume: AssetFieldTypeEnum.Volume,
                isPartOfIssue: AssetFieldTypeEnum.Issue,
                isPartOfPages: AssetFieldTypeEnum.Pages,
                localField1: AssetFieldTypeEnum.LocalField1,
                localField2: AssetFieldTypeEnum.LocalField2,
                localField3: AssetFieldTypeEnum.LocalField3,
                localField4: AssetFieldTypeEnum.LocalField4,
                localField5: AssetFieldTypeEnum.LocalField5,
                localField6: AssetFieldTypeEnum.LocalField6,
                localField7: AssetFieldTypeEnum.LocalField7,
                localField8: AssetFieldTypeEnum.LocalField8,
                localField9: AssetFieldTypeEnum.LocalField9,
                localField10: AssetFieldTypeEnum.LocalField10,
                localField11: AssetFieldTypeEnum.LocalField11,
                localField12: AssetFieldTypeEnum.LocalField12,
                localField13: AssetFieldTypeEnum.LocalField13,
                localField14: AssetFieldTypeEnum.LocalField14,
                localField15: AssetFieldTypeEnum.LocalField15,
            };

            this.depositFormSvc
                .getResearcherFormConfiguration(
                    fullAssetPageRep.resourceTypeValue,
                )
                .subscribe((config) => {
                    const fieldRequiredMap = new Map<AssetFieldType, boolean>();
                    fieldRequiredMap.set(AssetFieldTypeEnum.AssetType, true);
                    config.depositSections.forEach((section) => {
                        section.studentDepositFields.forEach((field) => {
                            const fieldType = fieldTypeMap[field.fieldName];
                            if (fieldType) {
                                fieldRequiredMap.set(
                                    fieldType,
                                    field.mandatory,
                                );
                            }
                        });
                    });
                    this.fieldRequiredMap.set(fieldRequiredMap);
                });

            this.mastForm.patchValue(
                {
                    [AssetFieldTypeEnum.AssetType]:
                        fullAssetPageRep.resourceTypeValue,
                    [AssetFieldTypeEnum.Title]: getTranslatableValue(
                        titles?.titlesList,
                        currLang,
                    )?.[0],
                    [AssetFieldTypeEnum.Subtitle]: getTranslatableValue(
                        titles?.subTitlesList,
                        currLang,
                    )?.[0],
                    [AssetFieldTypeEnum.Doi]: this.getDOI(),
                },
                { emitEvent: false },
            );
            const pubDetails =
                fullAssetPageRep?.entityModel?.publicationDetails;
            let pagesDisplay;
            if (pubDetails?.spage && pubDetails?.epage) {
                pagesDisplay = `${pubDetails.spage}-${pubDetails.epage}`;
            } else {
                pagesDisplay = pubDetails?.spage || pubDetails?.epage;
            }
            this.pubDetailsForm.patchValue(
                {
                    [AssetFieldTypeEnum.Volume]: pubDetails?.volume,
                    [AssetFieldTypeEnum.Issue]: pubDetails?.issue,
                    [AssetFieldTypeEnum.Pages]: pagesDisplay,
                },
                { emitEvent: false },
            );
            this.buildAssetsIdentifiersToDisplay();

            this.relations = fullAssetPageRep.relations;
            this.doi = this.getDOI();
            if (this.route.snapshot.fragment) {
                this.scrollToSection();
            }
            if (this.reportUsage()) {
                this.assetPageService
                    .updateMetadataViewStatistics(
                        this.mmsID,
                        this.fullAssetPageRep()?.entityModel.repId,
                    )
                    .subscribe();
            }
            this.initWOSIdentifier();
            this.assetPageService
                .getInCitesHighlights(this.mmsID)
                .subscribe((_) => this.incitesHighlights.set(_));

            const localFields = [];
            const lfModel =
                this.fullAssetPageRep()?.entityModel?.localFields?.fields;
            for (const key in lfModel) {
                const lfObj = lfModel[key];
                const fieldName = 'LocalField' + lfObj.fieldNumber;

                if (lfObj.fieldValue) {
                    localFields.push({
                        parentId: this.mmsID,
                        code: fieldName,
                        localFieldValue: lfObj.fieldValue,
                    });
                }
            }

            this.localFields.set(localFields);

            this.parseSdgs();
            this.sdgRevisions.set(
                this.sdgs()?.map(
                    (number) => 'SDG' + number.toString()?.padStart(2, '0'),
                ),
            );

            this.displayMode.update((mode) => {
                if (mode === 'edit' && !this.isEditable()) {
                    console.info('edit mode and not editable');
                    this.router.navigate(['.'], {
                        queryParamsHandling: 'merge',
                        queryParams: { mode: 'viewchanges' },
                        replaceUrl: true,
                        relativeTo: this.route,
                    });
                    return 'viewchanges';
                } else if (
                    mode !== 'viewchanges' &&
                    (!this.showEditBtn() || !this.isEditable())
                ) {
                    return 'view';
                } else {
                    return mode;
                }
            });
        }
    }

    parseSdgs() {
        const sdgList =
            ['edit', 'viewchanges'].includes(this.displayMode()) &&
            this.assetRevision?.[AssetFieldTypeEnum.Sdg]
                ? this.assetRevision?.[AssetFieldTypeEnum.Sdg]
                : this.fullAssetPageRep()?.entityModel.sdgList;
        if (sdgList?.length > 0) {
            this.isSdgsFromIncites.set(false);
            this.sdgs.set(
                sdgList.map((sdg) =>
                    parseInt(
                        (typeof sdg == 'string' ? sdg : sdg.code).replace(
                            /\D*(\d+)/,
                            '$1',
                        ),
                    ),
                ) ?? [],
            );
        } else {
            this.isSdgsFromIncites.set(true);
            this.assetPageService.getInCitesSdgs(this.mmsID).subscribe((_) => {
                this.sdgs.set(
                    _?.filter((sdgObj) => sdgObj.code).map((sdgObj) =>
                        // transform 'SDG01' to 1
                        parseInt(sdgObj.code?.substring(3)),
                    ) ?? [],
                );
            });
        }
    }

    initWOSIdentifier() {
        const assetIdentifiers =
            this.fullAssetPageRep()?.entityModel?.identifiers?.assetIdentifiers;
        if (assetIdentifiers?.WOS?.length > 0) {
            this.wosIdentifier = assetIdentifiers.WOS[0];
        }
    }

    onError(error: HttpErrorResponse) {
        this.loading.set(false);

        const errorParts = /([\w]+)(?:\: )?(.+)?/.exec(error.error);
        switch (error.status) {
            case 410: // deleted asset
            // removed as per URM-180791
            // this.emptyRecordTitle = errorParts[2];

            // eslint-disable-next-line no-fallthrough
            case 403: // suppressed asset
            case 404: // nonexisting asset
                this.errorStatus = errorParts[1].toLowerCase();
                break;
            case 500: // internal server error
                this.errorStatus = 'server_error';
                break;
            default:
                this.errorStatus = 'unknown';
        }
    }

    handleStatistics() {
        const file = this.files()[this.fileViewBtnIdx()];
        this.updateFilesStatistics(file, 'VIEW');
    }

    updateFilesStatistics(downloadedFile, action: string) {
        const params = {
            repId: downloadedFile.esploroFileModel.repId,
            mmsId: downloadedFile.esploroFileModel.mmsId,
            pid: downloadedFile.esploroFileModel.mid,
        };
        this.assetPageService.updateStatistics(params, action).subscribe();
    }

    buildAssetsIdentifiersToDisplay() {
        const assetsIdentifiers =
            this.fullAssetPageRep()?.entityModel?.identifiers?.assetIdentifiers;
        if (
            assetsIdentifiers &&
            ['edit', 'viewchanges'].includes(this.displayMode()) &&
            this.assetRevision[AssetFieldTypeEnum.Doi]
        ) {
            assetsIdentifiers.DOI = [
                this.assetRevision[AssetFieldTypeEnum.Doi],
            ];
        }
        this.identifiersCodesToDisplay.forEach((identifier) => {
            identifier = identifier
                .replace(FullAssetPage.IDENTIFIERS_PREFIX_IN_CONFIGURATION, '')
                .toUpperCase();
            let identifierValue = assetsIdentifiers?.[identifier];
            if (
                identifierValue &&
                identifierValue.length > 0 &&
                identifierValue[0]
            ) {
                if (
                    identifier === FullAssetPage.DOI_IDENTIFIER &&
                    this.isDOILinkableByConfiguration
                ) {
                    identifierValue =
                        FullAssetPage.DOI_LINK_PREFIX + identifierValue[0];
                } else if (
                    identifier === FullAssetPage.HANDLE_IDENTIFIER &&
                    this.isHandleLinkableByConfiguration
                ) {
                    identifierValue =
                        FullAssetPage.HANDLE_LINK_PREFIX + identifierValue[0];
                }
                this.assetsIdentifiersToDisplay[identifier.toLowerCase()] =
                    identifierValue;
            }
        });
    }

    getDOI(): string {
        const doi =
            ['edit', 'viewchanges'].includes(this.displayMode()) &&
            this.assetRevision[AssetFieldTypeEnum.Doi]
                ? [this.assetRevision[AssetFieldTypeEnum.Doi]]
                : this.record()?.esploroAssetForPortalFullAssetPage?.entityModel
                      ?.identifiers?.assetIdentifiers?.DOI;
        return doi?.length > 0 ? doi[0] : '';
    }

    accessibleFiles = (file) => !file.haveAccessRight;

    buildConfigurationForAssetFullPage() {
        const config = this.cfgSvc.portalConfigurationByDefaultAssetType();
        this.essentials = config?.essentials || [];
        this.initIdentifiersCodesForDisplay();
        this.essentials = this.essentials.filter(
            (essential) =>
                essential.active &&
                essential.code !== 'access' &&
                essential.code !== 'license' &&
                essential.code !== 'identifiers',
        );
        this.shareTargets = this.parseShareActions(config?.shareActions);
    }

    initIdentifiersCodesForDisplay() {
        const identifiersConfiguration = this.essentials.filter(
            (essential) => essential.code === 'identifiers',
        )[0];
        if (identifiersConfiguration?.active) {
            const identifiersListToDisplay =
                identifiersConfiguration?.identifiers.filter(
                    (identifier) => identifier.active,
                ) || [];
            this.identifiersCodesToDisplay = identifiersListToDisplay.map(
                (identifier) => {
                    return identifier.identifierCode;
                },
            );
            this.isDOILinkableByConfiguration =
                this.getIsLinkableIdentifierByConfig(
                    identifiersListToDisplay,
                    'doi',
                );
            this.isHandleLinkableByConfiguration =
                this.getIsLinkableIdentifierByConfig(
                    identifiersListToDisplay,
                    'handle',
                );
        }
    }

    getIsLinkableIdentifierByConfig(
        identifiersListToDisplay: FullAssetPageIdentifiersConfiguration[],
        identifier: string,
    ) {
        let linkable = false;
        const identifierArr = identifiersListToDisplay.filter(
            (identifierConfig) =>
                identifierConfig.identifierCode ===
                'esploroAssetModel.identifiers.' + identifier,
        );
        if (identifierArr.length > 0) {
            linkable = identifierArr[0].linkable;
        }
        return linkable;
    }

    scrollToSection() {
        setTimeout(() => {
            this.viewportScroller.scrollToAnchor(this.route.snapshot.fragment);
        }, 100);
    }

    isOpenAccess = computed(
        () => this.fullAssetPageRep()?.openAccessIndicator === 'Yes',
    );

    isPeerReviewed = computed(
        () => this.fullAssetPageRep()?.peerReviewStatus === 'Yes',
    );

    goToFilesAndLinksSection() {
        this.router.navigate(['.'], {
            relativeTo: this.route,
            fragment: 'files_and_links',
            queryParamsHandling: 'preserve',
        });
    }

    showExportDialog() {
        const dialogClosed = new Subject<null>();
        this.exportersService
            .showAssetExportDialog({
                dialogTitle: this.getTranslation(
                    'research.portal.fulldisplay.sendTo.export.title',
                    {},
                ),
                dialogCancel: this.getTranslation(
                    'research.portal.fulldisplay.sendTo.export.close',
                    {},
                ),
                labels: {
                    to: this.getTranslation(
                        'research.portal.fulldisplay.sendTo.export.to',
                        {},
                    ),
                    copy: this.getTranslation(
                        'research.portal.fulldisplay.sendTo.export.copy',
                        {},
                    ),
                    copied: this.getTranslation(
                        'research.portal.fulldisplay.sendTo.export.copy.success',
                        {},
                    ),
                },
                selectedAssets: [
                    {
                        id: this.mmsID,
                        title: this.fullAssetPageRep()?.title,
                        type: this.getTranslation(
                            'portal.' +
                                this.fullAssetPageRep()?.resourceTypeValue,
                            {},
                        ),
                    },
                ],
                selectedScope: 'single',
                exportTargets$: this.assetExportSvc.exportTargets$,
            })
            .pipe(takeUntil(dialogClosed))
            .subscribe((change) => {
                if (change.event === 'actionClick') {
                    this.assetExportSvc.handleExportActionClick(change, [
                        this.mmsID,
                    ]);
                }
                if (change.event === 'dialogClosed') {
                    this.assetExportSvc.clearOutput();
                    dialogClosed.next(null);
                    dialogClosed.complete();
                }
            });
    }

    showShareDialog() {
        const dialogClosed = new Subject<any>();
        this.shareService
            .showAssetShareDialog({
                dialogTitle: this.getTranslation(
                    'research.portal.fulldisplay.share.title',
                    {},
                ),
                dialogCancel: this.getTranslation(
                    'research.portal.fulldisplay.share.close',
                    {},
                ),
                labels: {
                    copy: this.getTranslation(
                        'research.portal.fulldisplay.share.copy',
                        {},
                    ),
                    copied: this.getTranslation(
                        'research.portal.fulldisplay.share.copy.success',
                        {},
                    ),
                    nativeShare: this.getTranslation(
                        'research.portal.fulldisplay.share.native',
                        {},
                    ),
                },
                shareData: {
                    url: this.fullAssetPageRep()?.permalink,
                    text: '',
                },
                shareTargets: this.shareTargets,
            })
            .pipe(takeUntil(dialogClosed))
            .subscribe((res) => {
                if (res.event === 'dialogClosed') {
                    dialogClosed.next(null);
                }
            });
    }

    getTranslation(code, params) {
        return this.translate.instant(code, params);
    }

    isAllMetricsOff = computed(() => {
        const metrics = this.sections()?.find(
            (section) => section.code === 'metrics',
        )?.metrics;

        if (!this.record() || !metrics) {
            return true;
        }

        return metrics.every((metric) => !metric.active);
    });

    isFilesAndLinksSectionDisplayed = computed(() => {
        return (
            this.files()?.length > 0 ||
            this.links()?.length > 0 ||
            this.fullAssetPageRep()?.openURLLink
        );
    });

    getFilesAndLinksSectionTitle = computed(() => {
        const onlyOpenUrl =
            !!this.fullAssetPageRep()?.openURLLink &&
            this.files()?.length === 0 &&
            this.links()?.length === 0;

        return `research.portal.fulldisplay.section.${onlyOpenUrl ? 'openURL' : 'filesLinks'}`;
    });

    ngOnDestroy() {
        this.assetSeoService.removeGoogleMetaTags();
    }

    parseShareActions(
        shareActions: FullAssetPageShareActionsConfiguration[],
    ): ShareTarget[] {
        const filteredActions = shareActions?.filter((action) => action.active);
        return filteredActions?.map((action) => {
            const labelTranslation = this.getTranslation(
                'esploro.research.conf.research.portal.label.prefix.' +
                    action.code,
                {},
            );

            return {
                key: action.code.toLowerCase(),
                openAs: action.state == 'new' ? 'tab' : 'popup',
                ...(labelTranslation ? { label: labelTranslation } : {}),
            };
        });
    }

    reportUsage() {
        return !(
            this.route.snapshot.queryParams &&
            this.route.snapshot.queryParams.skipUsageReporting &&
            (this.route.snapshot.queryParams.skipUsageReporting === 'true' ||
                (Array.isArray(
                    this.route.snapshot.queryParams.skipUsageReporting,
                ) &&
                    this.route.snapshot.queryParams.skipUsageReporting.includes(
                        'true',
                    )))
        );
    }

    goBack() {
        this._window?.history?.back();
    }

    showIncitesHighlights = computed(() => {
        const config = this.sections()?.find(
            (_) => _.code === 'incitesHighlights',
        );
        const incitesHighlights = this.incitesHighlights();
        if (!incitesHighlights || !config) {
            return false;
        }

        let showResponse = false;
        for (const sectionCfg of config.incitesHighlights) {
            let test: boolean;
            switch (sectionCfg.code) {
                case 'inciteESIIndicators':
                    test =
                        incitesHighlights.highlyCitedPaper ||
                        incitesHighlights.hotPaper;
                    break;
                case 'inciteCollaboration':
                    test =
                        incitesHighlights.institutionCollaboration ||
                        incitesHighlights.industryCollaboration ||
                        incitesHighlights.internationalCollaboration;
                    break;
                case 'inciteCitationTopics':
                    test =
                        incitesHighlights.metricsValueMap?.ct?.filter(
                            (_) => _.subject,
                        ).length > 0;
                    break;
                case 'inciteWOSResearchAreas':
                    test =
                        incitesHighlights.metricsValueMap?.wos?.filter(
                            (_) => _.subject,
                        ).length > 0;
                    break;
                case 'inciteESIResearchAreas':
                    test =
                        incitesHighlights.metricsValueMap?.esi?.filter(
                            (_) => _.subject,
                        ).length > 0;
                    break;
            }
            showResponse = showResponse || (sectionCfg.active && test);
        }
        return showResponse;
    });

    toggleDisplayMode() {
        this.assetPageService.toggleNavigation(this.displayMode() === 'edit');
    }

    onMastFormFieldChanged(fieldType: AssetFieldType, newValue: any) {
        const control = this.mastForm.get(fieldType);
        control.patchValue(newValue);
        control.markAsDirty();
    }

    onMastFormSubmit() {
        this.sectionSubmitInProgress.set(true);
        const changes = [];
        for (let fieldKey in this.mastForm.controls) {
            const field = this.mastForm.get(fieldKey);
            if (field.dirty) {
                this.assetRevision[fieldKey] = field.value;
            }
        }

        for (let assetFieldType in this.assetRevision) {
            const value = this.assetRevision[assetFieldType];
            changes.push({
                assetFieldType,
                value:
                    typeof value === 'string' ? value : JSON.stringify(value),
            });
        }
        this.assetPageService
            .saveRevisionChanges(this.mmsID, changes)
            .subscribe(() => {
                this.sectionSubmitInProgress.set(false);
                this.isMastFormOpen.set(false);
                this.buildAssetsIdentifiersToDisplay();
            });
    }

    onSaveSdgs() {
        this.sectionSubmitInProgress.set(true);
        this.assetRevision[AssetFieldTypeEnum.Sdg] = this.sdgRevisions();
        this.assetPageService
            .saveRevisionChanges(this.mmsID, [
                {
                    assetFieldType: AssetFieldTypeEnum.Sdg,
                    value: JSON.stringify(this.sdgRevisions()),
                },
            ])
            .subscribe(() => {
                this.sectionSubmitInProgress.set(false);
                this.isSdgFormOpen.set(false);
                this.isSdgsFromIncites.set(false);
                this.parseSdgs();
            });
    }

    onPubDetailsFormSubmit() {
        this.sectionSubmitInProgress.set(true);
        const changes = [];
        for (let fieldKey in this.pubDetailsForm.controls) {
            const field = this.pubDetailsForm.get(fieldKey);
            if (field.dirty) {
                this.assetRevision[fieldKey] = field.value;
            }
        }

        for (let assetFieldType in this.assetRevision) {
            const value = this.assetRevision[assetFieldType];
            changes.push({
                assetFieldType,
                value:
                    typeof value === 'string' ? value : JSON.stringify(value),
            });
        }
        this.assetPageService
            .saveRevisionChanges(this.mmsID, changes)
            .subscribe(() => {
                this.sectionSubmitInProgress.set(false);
                this.isPubDetailsFormOpen.set(false);
            });
    }

    onSubmitBtnClick(dialogTemplate) {
        const dialogRef = this.dialog.open(dialogTemplate, {
            disableClose: true,
            maxWidth: 720,
        });
        dialogRef
            .afterClosed()
            .pipe(
                filter((val) => !!val),
                switchMap(() => this.submitRevision$),
            )
            .subscribe();
    }

    parseRevisionChanges(data: AssetRevisionChangesDTO) {
        for (const change of data.changes) {
            let value;
            try {
                value = JSON.parse(change.value);
            } catch (e) {
                value = change.value || '';
            }

            this.assetRevision[change.assetFieldType] = value;
            switch (change.assetFieldType) {
                case AssetFieldTypeEnum.AssetType:
                case AssetFieldTypeEnum.Title:
                case AssetFieldTypeEnum.Subtitle:
                case AssetFieldTypeEnum.Doi:
                    this.mastForm.get(change.assetFieldType)?.patchValue(value);
                    break;
                case AssetFieldTypeEnum.Volume:
                case AssetFieldTypeEnum.Issue:
                case AssetFieldTypeEnum.Pages:
                    this.pubDetailsForm
                        .get(change.assetFieldType)
                        ?.patchValue(value);
                    break;
                case AssetFieldTypeEnum.Sdg:
                    this.sdgRevisions.set(value);
                    this.parseSdgs();
                    break;
                case AssetFieldTypeEnum.LocalField1:
                case AssetFieldTypeEnum.LocalField2:
                case AssetFieldTypeEnum.LocalField3:
                case AssetFieldTypeEnum.LocalField4:
                case AssetFieldTypeEnum.LocalField5:
                case AssetFieldTypeEnum.LocalField6:
                case AssetFieldTypeEnum.LocalField7:
                case AssetFieldTypeEnum.LocalField8:
                case AssetFieldTypeEnum.LocalField9:
                case AssetFieldTypeEnum.LocalField10:
                case AssetFieldTypeEnum.LocalField11:
                case AssetFieldTypeEnum.LocalField12:
                case AssetFieldTypeEnum.LocalField13:
                case AssetFieldTypeEnum.LocalField14:
                case AssetFieldTypeEnum.LocalField15:
                    const code = getAssetFieldTypeKey(change.assetFieldType);
                    const localFields = [...this.localFields()];
                    const lfListEntry = localFields.find(
                        (localField) => localField.code === code,
                    );

                    if (lfListEntry) {
                        lfListEntry.localFieldValue = value;
                    } else {
                        localFields.push({
                            parentId: this.mmsID,
                            code,
                            localFieldValue: value,
                        });
                    }
                    this.localFields.set(localFields);
                    break;
            }
        }
        this.buildAssetsIdentifiersToDisplay();
        this.doi = this.getDOI();
    }

    setupRevisionObservables() {
        this.submitRevision$ = this.assetPageService.entityId$.pipe(
            tap(() => this.submitLoading.set(true)),
            switchMap((id) =>
                this.assetPageService.submitRevision(id, this.submitNote()),
            ),
            switchMap(() => this.pageData$),
            switchMap(() => this.getRevisionChanges$),
            tap(() => this.submitLoading.set(false)),
        );

        this.getRevisionChanges$ = this.assetPageService.entityId$.pipe(
            tap(() => (this.assetRevision = {})),
            switchMap((id) => this.assetPageService.getRevisionChanges(id)),
            tap((res) => this.parseRevisionChanges(res)),
            switchMap(() => this.revisionConfig$),
        );

        this.getPendingChanges$ = this.assetPageService.entityId$.pipe(
            tap(() => (this.assetRevision = {})),
            switchMap((id) => this.assetPageService.getPendingChanges(id)),
            tap((res) => this.parseRevisionChanges(res)),
            switchMap(() => this.revisionConfig$),
        );
    }

    handleLocalFieldsChanged(fieldList: EntityLocalFields[]) {
        for (const field of fieldList) {
            const key = AssetFieldTypeEnum[field.code];
            this.assetRevision[key] = field.localFieldValue;
        }
    }

    protected readonly isLocalField = isLocalField;
}
